module.exports = __webpack_public_path__ + "img/default.38352878.png";